import React from 'react';
import PropTypes from 'prop-types';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, {bindTrigger, bindMenu} from 'material-ui-popup-state';
import {CircularProgress, Divider, IconButton} from '@mui/material';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {usePopupState} from 'material-ui-popup-state/hooks';

const ThreeDotsMenu = (props) => {
    const handleClick = (event) => {
        event.stopPropagation();
    };

    const popupState = usePopupState({variant: 'popover', popupId: props.prTag});
    const popupStateToUse = props.popupState ?? popupState;

    const useRequestStore = requestStores.get(props.prTag);
    const EPRId = useRequestStore((state) => state.EPRId);

    const propsColor = props.style?.color || null;

    return (
        <div onClick={handleClick} style={{...props?.style}}>
            <PopupState variant="popover">
                {() => (
                    <React.Fragment>
                        <IconButton
                            sx={{color: propsColor ?? '#CCCBCB'}}
                            {...bindTrigger(popupStateToUse)}>
                            <MoreVertIcon data-cy={`three_dots_${EPRId}`}/>
                        </IconButton>
                        <Menu {...bindMenu(popupStateToUse)}>
                            {props.isAnyPRSelected ? [
                                <MenuItem
                                    key="apply-selection"
                                    disabled
                                    sx={{
                                        fontWeight: 'bold',
                                        opacity: '1 !important',
                                    }}
                                >
                                    Apply to selection
                                </MenuItem>,
                                <Divider key="divider" />,
                            ] : null}
                            {props.items.map((item, idx) => {
                                const itemDisabled = item.disabled || ((props.loading || props.massSubmitLoading || props.massCopyLoading || props.massDeleteLoading) && (item.title === 'Submit' || item.title === 'Save' || item.title === 'Copy' || item.title === 'Delete'));
                                return (
                                    <MenuItem
                                        key={idx}
                                        onClick={() => {
                                            item.onClick?.('three_dots');
                                            item?.closeOnClick && popupStateToUse.close();
                                        }}
                                        disabled={itemDisabled}
                                        data-cy={item.dataCy}
                                    >
                                        {item.title || 'Undefined'}
                                        {(props.loading || props.massSubmitLoading) && (item.title === 'Submit' || item.title === 'Save') && (
                                            <CircularProgress size={16} sx={{marginLeft: '6px'}} />
                                        )}
                                        {props.massCopyLoading && item.title === 'Copy' && (
                                            <CircularProgress size={16} sx={{marginLeft: '6px'}} />
                                        )}
                                        {props.massDeleteLoading && item.title === 'Delete' && (
                                            <CircularProgress size={16} sx={{marginLeft: '6px'}} />
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Menu>
                    </React.Fragment>
                )}
            </PopupState>
        </div>
    );
};

export default ThreeDotsMenu;
ThreeDotsMenu.propTypes = {
    prTag: PropTypes.string,
    items: PropTypes.array,
    loading: PropTypes.bool,
    massSubmitLoading: PropTypes.bool,
    massCopyLoading: PropTypes.bool,
    massDeleteLoading: PropTypes.bool,
    style: PropTypes.object,
    disabledButtons: PropTypes.object,
    popupState: PropTypes.object,
    isAnyPRSelected: PropTypes.bool,
};

ThreeDotsMenu.defaultProps = {
    isAnyPRSelected: false,
};
